import React from 'react';
import User from '../types/User';
import Gravatar from './Gravatar';

const UserCell: React.FC<{ user: User; hideGravatar?: boolean }> = ({
  user,
  hideGravatar,
}) => (
  <div className="flex items-center">
    {!hideGravatar && (
      <Gravatar
        email={user.email}
        internal={user.internal}
        isInstructor={user.isInstructor}
      />
    )}
    <div className={hideGravatar ? '' : 'ml-4'}>
      <div className="text-sm font-medium">{user.name}</div>
      <div className="text-sm text-gray-500">{user.email}</div>
    </div>
  </div>
);

export default UserCell;
